import type { Consumer } from '@rails/actioncable';
import { parseVideoUpdate, type VideoStatusSubscriber } from '@shared/dream-components';

import { createCommunityConsumer } from '~/services/cable';

// One socket shared by every open video status subscription, opened on the first
// and closed with the last, so pages only connect while a video is processing.
// The channel only accepts the video's owner; anyone else is quietly rejected.
// A repeat subscription to the same video on this socket gets no initial snapshot,
// so it suits the feed player, which polls, but not the composer, which keeps its own.
let consumer: Consumer | null = null;
let openSubscriptions = 0;

export const subscribeToVideoStatus: VideoStatusSubscriber = (videoId, onUpdate) => {
  consumer ??= createCommunityConsumer();
  if (!consumer) return () => {};

  const subscription = consumer.subscriptions.create(
    { channel: 'OrchidCable::CommunityVideoChannel', video_id: videoId },
    {
      received: (data: unknown) => {
        const update = parseVideoUpdate(data);
        if (update) onUpdate(update);
      },
    },
  );
  openSubscriptions += 1;

  let open = true;
  return () => {
    if (!open) return;
    open = false;
    subscription.unsubscribe();
    openSubscriptions -= 1;
    if (openSubscriptions === 0) {
      consumer?.disconnect();
      consumer = null;
    }
  };
};
